import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36dad2a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "Home-container container-fluid",
  style: {"padding":"0 10%"}
}
const _hoisted_2 = {
  key: 0,
  style: {"position":"relative"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/pictures/infoScheme/main.png",
  class: "image"
}, null, -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Общая схема"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("работы с программой")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_InfoScheme = _resolveComponent("InfoScheme")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_DxButton, {
              class: "Home-button",
              text: "Открыть",
              id: "button",
              type: "default",
              "styling-mode": "outlined",
              onClick: _ctx.openScheme
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showReadme)
      ? (_openBlock(), _createBlock(_component_InfoScheme, {
          key: 1,
          onCloseScheme: _ctx.closeScheme
        }, null, 8, ["onCloseScheme"]))
      : _createCommentVNode("", true)
  ]))
}